import { useMutation } from "@tanstack/react-query";
import { getCMAPresentationApi } from "../../apis/comps/presentation/api-factories";

type Props = {
  onSuccess?: (data: { url: string }) => void;
};

export type Params = {
  id: string;
  sectionId: string;
  file: File;
};

export const useUploadPresentationSectionImage = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getCMAPresentationApi();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      return api.cMAPresentationControllerUploadSectionFile({
        ...params,
      });
    },
    onError: async (error) => {
      console.error(`Failed to upload section image`, error);
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
  });

  return mutation;
};
